import React from "react";
import * as styles from "./Billboard.module.css";
import { GatsbyImage } from "gatsby-plugin-image";
import CopyBlock from "../CopyBlock";
import LogoRail from "../LogoRail";

const Billboard = ({ props }) => {
  const {
    contentVerticalAlign,
    contentHorizontalAlign,
    contentWidth,
    copy,
    backgroundImage,
    backgroundOverlayColor,
    logoRail,
  } = props;

  let verticalClass = `vertical${
    contentVerticalAlign.charAt(0).toUpperCase() + contentVerticalAlign.slice(1)
  }`;

  let horizontalClass = `horizontal${
    contentHorizontalAlign.charAt(0).toUpperCase() +
    contentHorizontalAlign.slice(1)
  }`;

  let widthClass = `width${
    contentWidth.charAt(0).toUpperCase() +
    contentWidth.slice(1).replaceAll(" ", "")
  }`;

  return (
    <div className={styles.billboard}>
      {backgroundImage && (
        <>
          <GatsbyImage
            image={backgroundImage.gatsbyImageData}
            alt={backgroundImage.description}
            className={styles.backgroundImage}
          />
          <div
            className={`${styles.veilOfDarkness} ${styles[backgroundOverlayColor]} `}
          />
        </>
      )}
      <div
        className={`${styles.contentContainer} ${styles[verticalClass]} ${styles[horizontalClass]}`}
      >
        <div
          // data-aos="fade-up"
          // data-aos-duration="900"
          className={`${styles.contentWrapper} ${styles[widthClass]}`}
        >
          <CopyBlock props={copy} />
        </div>
      </div>
      {logoRail && (
        <div className={styles.logoRail}>
          <LogoRail props={logoRail} />
        </div>
      )}
    </div>
  );
};

export default Billboard;
